import { ReactNode, useEffect, useState } from "react";
import useDetectScroll from "@smakss/react-scroll-direction";
import { cn } from "../../lib/utils";
import MerciLogo from "../../assets/header/MerciLogo.png";

const Link = ({ children, href, isActive }: { children: ReactNode; href: string, isActive?: boolean }) => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <a
      href={href}
      className={cn(
        "text-[#4D4D4D] cursor-pointer transition-colors hover:text-secondary-foreground active:text-cta-click relative",
        isActive && "text-[#CF1E20]",
      )}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      {children}
      {/* Active state border */}
      {isActive && (
        <div className="absolute -bottom-[4px] left-1/2 transform -translate-x-1/2 w-[20px] h-[2px] bg-cta-active" />
      )}
      {/* Hover state border with animation */}
      <div 
        className={cn(
          "absolute -bottom-[4px] left-1/2 transform -translate-x-1/2 w-full h-[2px] bg-secondary-foreground origin-center transition-all duration-250 ease-out",
          isHovered ? "scale-x-100" : "scale-x-0"
        )}
      />
    </a>
  );
};

const FullMenu = () => {
  return (
    <div
      className={cn(
        "fixed bg-white w-full justify-center shadow-lg transition-all duration-500 z-10 flex h-[100px]",
      )}
    >
      <div className="flex items-center w-full">
        <div
          className={cn(
            "ml-[50px] h-[29px] basis-[100px] transition-all duration-500 flex justify-center h-[57px] mt-[-10px] pt-[19px]",
          )}
        >
          <a href="https://www.merci.de">
            <img
              src={MerciLogo}
              alt="Merci logo"
              className="max-h-full max-w-full"
            />
          </a>
        </div>
        <div className="flex-1 flex justify-center gap-[44px] uppercase font-extrabold text-[13px] tracking-wide" />
        <div className="basis-[128px] mr-[50px] flex justify-end" />
      </div>
    </div>
  );
};

export default FullMenu;
